// extracted by mini-css-extract-plugin
export var growableInput = "_47-0";
export var tagContainer = "_47-2";
export var textInput = "_47-1";